module.exports = __webpack_public_path__ + "img/Noctiluca-1.7ee7d27b.png";